import { Box, Typography, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import Input from './Input.js';

const useStyles = makeStyles((theme) => ({
    numberedInputContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '600px',
        gap: theme.spacing(1),
    },
    numberLabel: {
        minWidth: '30px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: '4px',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    inputWrapper: {
        flex: 1,
    },
    deleteButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.light,
        },
    }
}));

const NumberedInput = ({
    number,
    id,
    label,
    placeholder,
    required,
    variant = "standard",
    className,
    value,
    onChange,
    error,
    helperText,
    disabled,
    type = "text",
    numberPosition = "left",
    showDelete = false,
    onDelete,
    ...otherProps
}) => {
    const classes = useStyles();

    const numberElement = (
        <Typography className={classes.numberLabel}>
            {number}
        </Typography>
    );

    const inputElement = (
        <div className={classes.inputWrapper}>
            <Input
                id={id}
                type={type}
                className={className}
                variant={variant}
                color="secondary"
                label={label || placeholder}
                value={value}
                error={error}
                helperText={helperText}
                disabled={disabled}
                required={required}
                onChange={onChange}
                {...otherProps}
            />
        </div>
    );

    const deleteElement = showDelete && onDelete && (
        <IconButton
            className={classes.deleteButton}
            onClick={onDelete}
            size="small"
            disabled={disabled}
        >
            <Delete />
        </IconButton>
    );

    return (
        <Box className={classes.numberedInputContainer}>
            {numberPosition === "left" && numberElement}
            {inputElement}
            {numberPosition === "right" && numberElement}
            {deleteElement}
        </Box>
    );
};

export default NumberedInput;